const state = {
    token: localStorage.getItem('token') || '',
    userInfo: {},
  };
  
  const mutations = {
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    SET_USER_INFO(state, user) {
      state.userInfo = user;
      // localStorage.setItem('userInfo', JSON.stringify(user));
    },
    CLEAR_USER(state) {
      state.token = '';
      state.userInfo = {};
      localStorage.removeItem('token');
      // localStorage.removeItem('userInfo');
    },
  };
  
  const actions = {
    saveLoginInfo({ commit }, user) {
      commit('SET_USER_INFO', user);
    },
    logout({ commit }) {
      commit('CLEAR_USER');
    }
  };
  
  const getters = {
    isLoggedIn: state => !!state.token,
    // 与平台前端和后端 AdminAllAccess 保持一致，使用接口返回的用户名。
    isAdmin: state => state.userInfo?.username === 'admin',
    userInfo: state => state.userInfo,
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  